import React from 'react';
import { Avatar, Divider, Dropdown, Menu, ConfigProvider } from 'antd';
import style from './style.module.less';
import { Layout } from 'antd';
import { inject, observer } from 'mobx-react';
import withRouter from '../withRouter';
import { computed } from 'mobx';
import TenantList from '../../page/TenantList';
import {
    DownOutlined,
    SwapOutlined,
    SettingOutlined,
    SafetyCertificateOutlined,
    ImportOutlined,
    ScheduleOutlined,
    TeamOutlined,
    DownloadOutlined,
    FileTextOutlined
} from '@ant-design/icons';
import theme from '../../theme';
import Setting from './Setting';
// 使用 CommonJS 方式导入 less 模块
const less = require('less'),
 modifyVars = less.modifyVars;
import Toast from '@/components/Toast';
import DownloadDrawer from '@/components/Header/DownloadDrawer';

const { Header } = Layout;

@inject('store')
@observer
class MainHeader extends React.Component {
    state = {
        isPlatform: false,
        showDownload: false,
        list: [],
        isDevelopment: window.location.origin === 'https://development.dev.grtcloud.net'
    };

    async componentDidMount() {
        const {
            store: { login }
        } = this.props;

        try {
            //获取租户第三方配置
            await login.getLoginAndOutConfig();
        } catch (error) {
            console.log(error);
        }

        if (/^platform/.test(window.location.host)) {
            this.setState({ isPlatform: true });
        } else {
            this.setState({ isPlatform: false });
            login.fetchList();
        }
    }

    onChange = (e) => {
        const { global } = this.props.store;

        global.setTheme(e.target.value);
        modifyVars(theme[`project_less_${e.target.value}`]);
        ConfigProvider.config({
            prefixCls: 'main',
            theme: theme[`antd_less_${e.target.value}`]
        });
    };
    togglePlatform = (platform) => {
        localStorage.setItem('topMenu', JSON.stringify({}));
        localStorage.setItem('item', JSON.stringify({}));
        window.location.href = `/${platform.side_url}`;
    };
    showSetting = () => {
        const { global } = this.props.store;

        global.setSettingVisible(true);
    };

    outLogin = () => {
        const {
            store: { login }
        } = this.props;

        login.outLogin();
    };
    //过滤可切换的端
    getSides = () => {
        const { global } = this.props.store,
            { sides = [], platform = {} } = global;
        let changeSides = sides.filter((ele) => ele.id !== platform.id),
            len = changeSides.length,
            res = [];
        if (len === 0) {
            return [{ hidden: true }];
        }
        changeSides.forEach((ele) => {
            res.push({
                key: ele.id,
                icon: ele.side_url === 'admin' ? <SettingOutlined /> : <ScheduleOutlined />,
                label: (
                    <a
                        onClick={() => {
                            this.togglePlatform(ele);
                        }}
                    >
                        {ele.side_name}
                    </a>
                )
            });
        });
        return res;
    };

    @computed
    showStudentEnd() {
        const { login } = this.props.store;
        let resule = false;

        login.tenantList?.studentTenants?.forEach((item) => {
            if (item.domain === window.location.host) {
                resule = true;
            }
        });
        return resule;
    }

    @computed
    showSwitch() {
        const { login } = this.props.store,
            tenantList = [...login.tenantList.studentTenants, ...login.tenantList.adminTenants];
        if (tenantList.length === 1 && login.tenantList.studentTenants.length + login.tenantList.adminTenants.length === 1) {
            return false;
        }
        return true;
    }

    getList = () => {
        const { login } = this.props.store;
        return [
            {
                key: '32',
                hidden: this.state.isPlatform,
                label: (
                    <a className={style['text-ellipsis']} style={{ width: '180px', cursor: 'text' }}>
                        {login.userInfo?.tenantName}
                    </a>
                )
            },
            {
                key: '31',
                hidden: this.state.isPlatform,
                label: (
                    <a
                        style={{ color: '#2f54eb' }}
                        onClick={() => {
                            localStorage.removeItem('topMenu');
                            login.setSwitchTenant(true);
                        }}
                    >
                        <SwapOutlined /> &nbsp; 切换
                    </a>
                )
            },
            {
                type: 'divider',
                hidden: this.state.isPlatform
            },

            ...this.getSides(),
            {
                key: '3',
                hidden: this.state.isPlatform || !this.showStudentEnd(),
                icon: <TeamOutlined />,
                label: (
                    <a
                        onClick={() => {
                            setTimeout(() => {
                                window.location.href = `https://${window.location.host}/web`;
                            }, 0);
                        }}
                    >
                        学员端
                    </a>
                )
            },

            {
                key: '1',
                hidden: login.userInfo?.third_data,
                icon: <SafetyCertificateOutlined />,
                label: (
                    <a
                        onClick={() => {
                            this.showSetting();
                        }}
                    >
                        账号与安全
                    </a>
                )
            },
            {
                key: '2',
                hidden: login.loginAndOutConfig?.logout_config?.can_logout === 0,
                danger: true,
                icon: <ImportOutlined />,
                label: (
                    <a
                        onClick={() => {
                            this.outLogin();
                        }}
                    >
                        退出登录
                    </a>
                )
            }
        ].filter((i) => {
            return !i.hidden;
        });
    };

    handleClickUnopenedFeatures() {
        Toast.error('功能建设中，敬请期待');
    }

    handleDownloadDrawer() {
        this.setState({ showDownload: true });
    }

    render() {
        const { global, login } = this.props.store;

        let list = this.getList();

        return (
            <Header>
                <div className={!global.shareGlobalData.showAsider ? `${style.header} ${style['hide-header']}` : style.header}>
                    {/* <div
                        onClick={this.handleClickUnopenedFeatures}
                        className={`${style.item_box} ${style['cursor-pointer']}`}
                        style={{ width: 'auto', paddingLeft: '24px' }}
                    >
                        <div>
                            <AppstoreOutlined />
                        </div>
                        <div>我的常用</div>
                    </div> */}
                    <div className={style.center}>
                        <div style={{ width: '80%' }}>{login.userInfo?.tenantName}</div>
                        {/* 主题：
                        <Radio.Group options={option} onChange={this.onChange} value={global.theme} optionType="button" buttonStyle="solid" /> */}
                    </div>
                    <div className={style.right}>
                        {/* <div onClick={this.handleClickUnopenedFeatures} className={`${style.item_box} ${style['cursor-pointer']}`}>
                            <div>
                                <BellOutlined />
                            </div>
                            <div>消息</div>
                        </div> */}
                        {this.state.isDevelopment ? (
                            <div
                                onClick={() => window.open('https://static.grtcloud.net/grt-components-doc/index.html?path=/')}
                                style={{ width: '100px', marginRight: '10px' }}
                                className={`${style.item_box} ${style['cursor-pointer']}`}
                            >
                                <div>
                                    <FileTextOutlined />
                                </div>
                                <div>组件文档</div>
                            </div>
                        ) : null}

                        <div onClick={this.handleDownloadDrawer.bind(this)} className={`${style.item_box} ${style['cursor-pointer']}`}>
                            <div>
                                <DownloadOutlined />
                            </div>
                            <div>下载</div>
                        </div>
                        {/* <div onClick={this.handleClickUnopenedFeatures} className={`${style.item_box} ${style['cursor-pointer']}`}>
                            <div>
                                <QuestionCircleOutlined />
                            </div>
                            <div>帮助</div>
                        </div> */}
                        <div>
                            <Divider type="vertical" />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                            <Avatar src={login.userInfo?.avatar || '/asset/images/avatar_default.png'} />
                            <Dropdown
                                overlay={<Menu items={list} />}
                                overlayStyle={{ width: '220px' }}
                                overlayClassName={style.dropMenu}
                                danger
                                trigger={['click']}
                            >
                                <span style={{ display: 'inline-flex' }}>
                                    <span className={style.user_info}> {`${login.userInfo?.adminInfo?.admin_name}，欢迎您`}</span>
                                    <DownOutlined />
                                </span>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                <Setting />
                <TenantList />
                <DownloadDrawer show={this.state.showDownload} onClose={() => this.setState({ showDownload: false })} />
            </Header>
        );
    }
}

export default withRouter(MainHeader);
